import React, { useState } from 'react'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'
import context from '@/context'
import { useDispatch } from '@/hooks/dispatch'
import { actionCreators } from '@/store/Identity'
import { push } from 'react-router-redux'

export function SelectInstitutionButton ({ institution, onChange }) {
  const [loading, setLoading] = useState(false)
  const actions = useDispatch({
    refresh: actionCreators.refresh,
    push
  })

  async function onSelect () {
    if (!institution) return
    setLoading(true)
    try {
      await context.api.institutionService.selectInstitution(institution.id)
      await actions.push('/')
      if (typeof onChange === 'function') { await onChange() }
      await actions.refresh()
    } catch (e) {
      setLoading(false)
    }
  }

  return (
    <Button color='primary' size='lg' onClick={onSelect} disabled={!institution} icon={loading ? 'loader bx-spin' : 'check'}>
      <Resx name='Institutions.SelectInstitution' />
    </Button>
  )
}



// WEBPACK FOOTER //
// ./src/report-app/pages/institution/selectButton.js